module.exports = __webpack_public_path__ + "22704e9e28cb4b009326b7e8cd52a2f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/milestoneImage/arm-2.svg
// module id = ./src/helpers/images/milestoneImage/arm-2.svg
// module chunks = 5